import moment from 'moment';
export const TODAY_SENTINEL = "today";

const TIMEZONE_ADORNMENT_FIELD_TYPES = ["date", "datetime", "timezone", "datewithusertimezone"];

export function isTimezoneDateField(row) {
  const fieldType = String(row?.fieldType || row?.FieldType || "").toLowerCase();
  return TIMEZONE_ADORNMENT_FIELD_TYPES.includes(fieldType);
}


export function normalizeToIso(value) {
  if (!value) return "";
  if (/^\d{4}-\d{2}-\d{2}(T\d{2}:\d{2}:\d{2})?$/.test(value)) return value;
  
  const mmddyyyy = value.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  if (mmddyyyy) return `${mmddyyyy[3]}-${mmddyyyy[1]}-${mmddyyyy[2]}`;
  if (value.includes("T")) {
    const dateTimeParts = value.match(/^(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2})/);
    if (dateTimeParts) return dateTimeParts[1];
    return value.substring(0, 10);
  }
  return value;
}

export function formatDateForDisplay(value, format) {
  if (!value) return "";
  if (format) {
    const m = moment(value, ['YYYY-MM-DD', 'YYYY-MM-DDTHH:mm:ss', moment.ISO_8601], true);
    if (m.isValid()) return m.format(format);
  }
  const iso = normalizeToIso(value);
  if (!iso) return value;
  const parts = iso.split("T")[0].split("-");
  if (parts.length === 3) return `${parts[1]}/${parts[2]}/${parts[0]}`;
  return value;
}

export function getTodayIsoDate() {
  return new Date().toISOString().substring(0, 10);
}

export const todayIso = getTodayIsoDate;

export function getDateConstraints(validation, referencedDateValue) {
  let maxDate;
  let minDate;
  validation.forEach((rule) => {
    if (rule.rule === "maxDate") {
      maxDate = rule.value === TODAY_SENTINEL ? getTodayIsoDate() : rule.value;
    }
    if (rule.rule === "minDate") {
      minDate = rule.value === TODAY_SENTINEL ? getTodayIsoDate() : rule.value;
    }
    if (rule.rule === "minDateField" && referencedDateValue) {
      minDate = normalizeToIso(referencedDateValue);
    }
  });
  return { maxDate, minDate };
}
